var voted_users_default = {
  "container": "gBogA",
  "webview": "jgjSg",
  "avatar_list": "WiIcE",
  "avatar": "_9D5Pf",
  "user_avatar": "MrPho",
  "modal": "qxGla",
  "voted_users_modal": "_0y3cR",
  "overlay": "jXA75",
  "user_card": "wAaq2",
  "user_name": "_0XWQ8",
  "voted_users_modal_header": "p-KpY",
  "cta": "oXpDn",
  "close_icon": "BMAwz",
  "title": "_1UzQO",
  "member_list_container": "_4sE4B",
  "member_list": "UuehY",
  "loader": "xwIZK",
  "anonymous_counter": "cR03k",
  "spinner": "_5QzPk",
  "spin": "_-7s9e"
};
export {
  voted_users_default as default
};
//# sourceMappingURL=voted-users-scss.js.map
